import Vue from 'vue';
import moment from 'moment';

Vue.filter('asDayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return dataStr ? moment(dataStr).format(pattern) : '';
});

//全局过滤器-处理日期
Vue.filter('fmtdate', (v) => {
  return moment(v).format('YYYY-MM-DD');
});

// Vue.filter('toThousands', (num) => (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'));
Vue.filter('toThousands', (num = 0) => {
  return Number(num).toLocaleString('en-US');
});

Vue.filter('toAmountotal', function (v) {
  try {
    const result = Number(v) || 0;
    return result.toFixed(0).replace(/(\d)(?=(\d{3})+($|\.))/g, '$1,');
  } catch (error) {
    return 0;
  }
});



// WEBPACK FOOTER //
// ./src/utils/filter.js